import React, { useState } from 'react';
import { fetchInterplantAggregateAssignmentView } from '../../apis/calls';
import {
  InterPlantAggregateAssignment,
  InterPlantAggregateConflict,
  TabbedViewWithDateSelect,
} from '../../components';
import { useAjaxCallbackWithIntervals } from '../../hooks';
import { usePlantAndLinesStore } from '../../providers/PlantAndLinesStore/PlantAndLinesStore';
import PropTypes from 'prop-types';

const InterPlantAggregateAssignmentView = ({ aggregate }) => {
  const [plant] = usePlantAndLinesStore().plantState;
  const [interPlantCount, setinterPlantCount] = useState(0);
  const [interPlantAggregateConflictCount, setInterPlantAggregateCount] = useState(0);
  const [handleInterPlantEdit, setinterPlantEdit] = useState(false);
  const [rowsDataForInterPlant, setRowsDataForInterPlant] = useState({
    loading: false,
    data: [],
    filteredData: [],
  });
  const [rowsDataForInterPlantConflict, setRowsDataForInterPlantConflict] = useState({
    loading: false,
    data: [],
    filteredData: [],
  });
  const handleInterPlantDataChange = count => {
    setinterPlantCount(count);
  };
  const handleInterPlantConflictCountChange = count => {
    setInterPlantAggregateCount(count);
  };
  const filterInterPlantRowsData = rowsData => {
    return rowsData.filter(data => {
      return (
        data.lineId
      );
    });
  };
  const filterEAgsnConflictRowsData = rowsData => {
    return rowsData.filter(data => {
      return (
        (data.lineId === null || data.lineId === undefined)
      );
    });
  };

  const loadPlannedInterPlant = async () => {
    try {
      if (plant.value) {
        setRowsDataForInterPlant(prevState => ({ ...prevState, loading: true }));
        const aggregateShopName = aggregate;
        const response = await fetchInterplantAggregateAssignmentView(
          plant.value,
          aggregateShopName,
        );
        const interPlantRowData = filterInterPlantRowsData(response.data);

        const sortInterplantData = interPlantRowData.sort((a, b) => {
          const dateA = new Date(a.parentPlannedProductionDate);
          const dateB = new Date(b.parentPlannedProductionDate);
          const dateDiff = dateA - dateB;
          if (dateDiff !== 0) return dateDiff;
          if (a.parentAsn < b.parentAsn) return -1;
          if (a.parentAsn > b.parentAsn) return 1;
          return 0;
        });


        if (sortInterplantData.length <= 0) {
          setRowsDataForInterPlant({
            data: [],
            loading: false,
          });
        } else {
          handleInterPlantDataChange(sortInterplantData.length);

          setRowsDataForInterPlant({
            data: sortInterplantData,
            filteredData: sortInterplantData,
            loading: false,
          });
        }

        const InterPlantRowData = filterEAgsnConflictRowsData(
          response.data,
        );
        handleInterPlantConflictCountChange(InterPlantRowData.length);
        setRowsDataForInterPlantConflict({
          data: InterPlantRowData,
          filteredData: InterPlantRowData,
          loading: false,
        });
      }
    } catch (err) {
      console.error('failed to load Emergency Agsn');
      setRowsDataForInterPlant({
        data: [],
        loading: false,
      });
      setRowsDataForInterPlantConflict({
        data: [],
        loading: false,
      });
    }
  };

  const lastRefreshedDateForInterPlant = useAjaxCallbackWithIntervals(
    rowsDataForInterPlant.loading,
    handleInterPlantEdit,
    loadPlannedInterPlant,
    aggregate,
    plant.value,
  );
  return (
    <TabbedViewWithDateSelect
      tabs={[
        {
          label: 'InterPlantAggregateAssignment',
          title: 'InterPlantAggregateAssignment',
          count: interPlantCount,
          component: InterPlantAggregateAssignment,
          props: {
            aggregate,
            rowsDataForInterPlant,
            lastRefreshedDate: lastRefreshedDateForInterPlant,
            setinterPlantEdit,
            loadPlannedInterPlant,
          },
        },
        {
          label: 'Conflict',
          title: 'Conflict',
          count: interPlantAggregateConflictCount,
          countColor: 'red',
          component: InterPlantAggregateConflict,
          props: {
            aggregate,
            rowsDataForInterPlantConflict,
            setRowsDataForInterPlantConflict,
            handleCountChange: handleInterPlantConflictCountChange,
            lastRefreshedDate: lastRefreshedDateForInterPlant,
            isInterPlantEdit: handleInterPlantEdit,
            setinterPlantEdit,
            loadPlannedInterPlant,
          },
        },
      ]}
      pageTitle=""
    />
  );
};
InterPlantAggregateAssignmentView.propTypes = {
  aggregate: PropTypes.string.isRequired,
};
export default InterPlantAggregateAssignmentView;
